import React from "react";
import { Box, Chip } from "@mui/material";

export function CategoryLanguageSelector({ languagesList, currentLanguage, setCurrentLanguage, names }) {
  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <label style={{ fontSize: "0.82rem", fontWeight: "700", color: "#1e293b" }}>
        2. Idioma / Língua da Interface
      </label>
      <Box style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {languagesList.map((lang) => {
          const isSelected = currentLanguage === lang.value;
          const hasTranslation = Boolean(names[lang.value]);
          return (
            <Chip
              key={lang.value}
              label={lang.label}
              size="small"
              onClick={() => setCurrentLanguage(lang.value)}
              style={{
                backgroundColor: isSelected ? "#181764" : hasTranslation ? "#e0e7ff" : "#f1f5f9",
                color: isSelected ? "#ffffff" : hasTranslation ? "#3730a3" : "#64748b",
                fontWeight: isSelected ? "700" : "500",
                border: isSelected ? "1px solid #181764" : "1px solid #cbd5e1",
                cursor: "pointer",
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
